(function ($) {
  'use strict';

  /**
   * Parallax Sections - Wipe Animations
   */

  var $parallax_section = $( '.js-parallax-section' );
  var controller = null;

  // Media Query - Reduced Motion
  var mql_reduced_motion = window.matchMedia( '(prefers-reduced-motion: reduce)' );
  var is_reduced_motion = mql_reduced_motion === true
    || mql_reduced_motion.matches === true;

  // Media Query - Max-Width
  var mql_med_screen_size = window.matchMedia( '(min-width: 47.5rem)' );
  var is_med_screen_size = mql_med_screen_size === true
    || mql_med_screen_size.matches === true;

  // Init
  if ( $parallax_section.length && ! is_reduced_motion && is_med_screen_size ) {
    initScrollMagic();
    $parallax_section.addClass( 'is-parallax-active' );
  }

  // Update state on Reduced Motion preference change
  $(mql_reduced_motion).on('change', function (e) {
    var is_updated_reduced_motion = e.originalEvent === true
      || e.originalEvent.matches === true;
    var is_controller_init = controller !== null && controller !== undefined;

    if ( $parallax_section.length ) {
      if ( ! is_updated_reduced_motion && ! is_controller_init ) {
        initScrollMagic();
        $parallax_section.addClass( 'is-parallax-active' );
      } else {
        controller = controller.destroy( true );
        $parallax_section.removeClass( 'is-parallax-active' );
      }
    }
  });

  // Update state on window size change
  $(mql_med_screen_size).on('change', function (e) {
    var is_updated_med_screen_size = e.originalEvent === true
      || e.originalEvent.matches === true;
    var is_controller_init = controller !== null && controller !== undefined;

    if ( $parallax_section.length ) {
      if ( is_updated_med_screen_size && ! is_controller_init ) {
        initScrollMagic();
        $parallax_section.addClass( 'is-parallax-active' );
      } else {
        controller = controller.destroy( true );
        $parallax_section.removeClass( 'is-parallax-active' );
      }
    }
  });

  // Setup panel parallax animations & pagination
  function initScrollMagic() {
    $parallax_section.each(function ( index ) {
      var $this_section = $(this);
      var $panels = $this_section.find( '.parallax-section-panel' );

      // Ensure section has more than 1 panel
      if ( ! $panels.length || $panels.length <= 1 ) {
        return false;
      }


      /**
       * Generate Pagination
       */

      var $pagination = $this_section.find( '.js-pagination-parallax' );
      var has_inner_items = $pagination.find( '.pagination-parallax-item' ).length;
      var section_index = index;

      if ( $pagination.length && ! has_inner_items ) {

        // Prep pagination list
        $pagination.html( '<ul></ul>' );

        // Prep panels & anchor links
        $panels.each(function ( index ) {
          var $this_panel = $(this);
          var panel_id = 'panel-' + section_index + '-' + index;
          var panel_label = $this_panel.attr( 'data-pagination-label' ) || index + 1;

          // Format planel el
          $this_panel.attr( 'id', panel_id );

          $pagination
            .find( 'ul' )
            .append( ''
              + '<li class="pagination-parallax-item">'
              + '<a href="#' + panel_id + '">'
              + '<span>' + panel_label + '</span>'
              + '</a>'
              + '</li>'
            );
        });
      }


      /**
       * Setup Animations
       */

      var $pagination_wrap = $this_section.find( '.js-pagination-parallax-wrap' );
      controller = new ScrollMagic.Controller();

      // Pin Pagination Wrap
      $pagination_wrap.each(function () {
        // Calculate Duration
        // - 100% of all panels
        // - Minus 100% of the last panel
        var duration = ( $panels.length * 100 ) - 100;
        var pinPaginationScene = new ScrollMagic.Scene({
          triggerElement: '.js-parallax-section-panels',
          triggerHook: 'onLeave',
          duration: duration + '%',
        });
        pinPaginationScene.setClassToggle( this, 'is-parallax-active' );
        pinPaginationScene.setPin( this, { pushFollowers: true });
        pinPaginationScene.addTo( controller );
      });

      // Pin Panels
      $panels.each(function ( index, panel ) {
        var $this_panel = $(this);
        var isLastPanel = index === $panels.length - 1;

        // Get the pagination item for this panel
        var $this_pagination_item = $pagination_wrap
          .find( 'a[href^="#"]' )
          .eq( $this_panel.index() )
          .parent( 'li' );

        // Pagination Items
        // - Toggles `is-active` class as you scroll through
        var paginationItemScene = new ScrollMagic.Scene({
          triggerElement: panel,
          triggerHook: 'onEnter',
          duration: '100%',
          offset: 500,
        });
        paginationItemScene.setClassToggle( $this_pagination_item[0], 'is-active' );
        paginationItemScene.addTo( controller );

        // Last Panel
        // - Init Scene - Allows us to link to start of scene
        // - Skip Pin - Allows content after animation to flow normally
        if ( isLastPanel ) {
          var pinLastPanelScene = new ScrollMagic.Scene({
            triggerElement: panel,
            triggerHook: 'onLeave',
            duration: '100%',
          });
          pinLastPanelScene.setClassToggle( panel, 'is-parallax-active' );
          pinLastPanelScene.addTo( controller );

          $this_pagination_item.on('click', function (e) {
            e.preventDefault();
            controller.scrollTo( pinLastPanelScene );
          });

          return true;
        }

        // All Other Panels
        // - Toggle class & set pin
        var pinPanelScene = new ScrollMagic.Scene({
          triggerElement: panel,
          triggerHook: 'onLeave',
          duration: '100%',
        });
        pinPanelScene.setClassToggle( panel, 'is-parallax-active' );
        pinPanelScene.setPin( panel, { pushFollowers: false });
        pinPanelScene.addTo( controller );

        $this_pagination_item.on('click', function (e) {
          e.preventDefault();
          controller.scrollTo( pinPanelScene );
        });

        return true;
      });

    });
  }

})(jQuery);
